/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReportForFirmwareGroupsEntryByStbGroupResponseCounters,
    ReportForFirmwareGroupsEntryByStbGroupResponseCountersFromJSON,
    ReportForFirmwareGroupsEntryByStbGroupResponseCountersFromJSONTyped,
    ReportForFirmwareGroupsEntryByStbGroupResponseCountersToJSON,
} from './ReportForFirmwareGroupsEntryByStbGroupResponseCounters';

/**
 * 
 * @export
 * @interface ReportForFirmwareGroupsEntryByStbGroupResponse
 */
export interface ReportForFirmwareGroupsEntryByStbGroupResponse {
    /**
     * 
     * @type {ReportForFirmwareGroupsEntryByStbGroupResponseCounters}
     * @memberof ReportForFirmwareGroupsEntryByStbGroupResponse
     */
    counters: ReportForFirmwareGroupsEntryByStbGroupResponseCounters;
}

export function ReportForFirmwareGroupsEntryByStbGroupResponseFromJSON(json: any): ReportForFirmwareGroupsEntryByStbGroupResponse {
    return ReportForFirmwareGroupsEntryByStbGroupResponseFromJSONTyped(json, false);
}

export function ReportForFirmwareGroupsEntryByStbGroupResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportForFirmwareGroupsEntryByStbGroupResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'counters': ReportForFirmwareGroupsEntryByStbGroupResponseCountersFromJSON(json['counters']),
    };
}

export function ReportForFirmwareGroupsEntryByStbGroupResponseToJSON(value?: ReportForFirmwareGroupsEntryByStbGroupResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'counters': ReportForFirmwareGroupsEntryByStbGroupResponseCountersToJSON(value.counters),
    };
}

